<template>

  <div>

    <template v-if="context.parent && context.parent.tag==='subForm'">
      <el-input v-if="type==='fill'" v-model="data[element.id]" :placeholder="element.attrs.placeholder"
                :disabled="context.authentication.isDisabled(element,data) || !context.authentication.isWrite(element)"
                @change="handleChange"></el-input>
      <div v-else-if="type==='detail'" :style="getStyle()">{{ data[element.id] || "⠀" }}</div>
    </template>

    <el-form-item v-else :required="context.authentication.isRequired(element)">
      <template #label>
      <span :style="{ color:'#344262','font-weight':context.form.setting.style.PC.title}">
        {{ element.label }}
        <form-element-tooltip :element="element"></form-element-tooltip>
      </span>
      </template>
      <el-input v-if="type==='fill'" v-model="data[element.id]" :placeholder="element.attrs.placeholder"
                :disabled="context.authentication.isDisabled(element,data)" @change="handleChange"></el-input>
      <div v-else-if="type==='detail'" class="design-detail" :style="getStyle()">{{ data[element.id] || "⠀" }}</div>
    </el-form-item>
  </div>


</template>

<script>

import {mapStores} from "pinia";
import {useFlowStore} from "@/stores/flow";
import {useFormStore} from "@/stores/form";
import {useHttpStore} from "@/stores/http";
import FormElementTooltip from "@/components/common/formElementTooltip.vue";
import {dynamicFunction, contextFunction} from "@/pojo/script";
import {debounce} from "lodash";

export default {
  components: {FormElementTooltip},
  props: {
    element: {
      type: Object,
      default: () => {
      }
    },
    context: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
      data: {},
      type: '',
      debouncedHandler: debounce((newValue, oldValue) => {
        try {
          this.data[this.element.id] = dynamicFunction(this.element.default.script.value, {...this.data, ...(this.context.rawData || {})});
        } catch (e) {
          console.error(this.element.label, this.element.default.script.value, e)
        }
      }, 1),
    }
  },
  computed: {
    ...mapStores(useFlowStore, useHttpStore, useFormStore)
  },
  created() {
    this.data = this.context.data;
    this.type = this.flowStore.typeOfElement(this.element, this.context);
  },
  mounted() {
    this.initWatch();
  },
  unmounted() {

    if (this.element.default?.script?.value)
      this.debouncedHandler();
  },
  methods: {
    async handleChange() {
      if (this.element.listen?.script.value) {
        await contextFunction(this.element.listen.script.value, {...this.data, ...(this.context.rawData || {})}, this.context.rawData || this.data);
      }
    },
    initWatch() {
      if (this.type === 'fill' && this.element.default.select === 'script' && this.element.default.script.value.length > 0) {

        if (!this.data[this.element.id] || this.element.default.isAlwaysScript) {
          this.debouncedHandler()
        }

        let columns = this.formStore.columnsFlatMap(this.context.form);
        if (this.context.rawData) {

          Object.keys(this.context.rawData)
              .filter(filter => filter !== this.element.id)
              .filter(filter => columns.some(some => !some.parent && some.id === filter))
              .filter(filter => this.element.default.script.value.includes(filter)).forEach(key => {

            this.$watch(`context.rawData.${key}`, this.debouncedHandler, {
              deep: true,
              immediate: false
            });
          });
        }

        Object.keys(this.data)
            .filter(filter => filter !== this.element.id)
            .filter(filter => columns.some(column => column.id === filter))
            .filter(filter => this.element.default.script.value.includes(filter)).forEach(key => {

          this.$watch(`data.${key}`, this.debouncedHandler, {
            deep: true,
            immediate: false
          });
        });

      }
      if (this.type === 'fill' && this.element.default.select === 'http') {
        let http = this.element.default.http;
        if (http.immediate) {
          this.http();
        }

        this.$watch(`data.${http.trigger}`, (newValue, oldValue) => {
          this.http()
        }, {
          deep: true,
          immediate: false
        });
      }
    },
    http() {
      let http = this.deepClone(this.element.default.http);
      http.params.forEach(item => {
        try {
          item.value = dynamicFunction(item.script.value, this.data);
        } catch (e) {
          console.error(this.element.default.script.value, e)
        }
      })
      http.headers.forEach(item => {
        try {
          item.value = dynamicFunction(item.script.value, this.data);
        } catch (e) {
          console.error(this.element.default.script.value, e)
        }
      })
      http.bodies.forEach(item => {
        try {
          item.value = dynamicFunction(item.script.value, this.data);
        } catch (e) {
          console.error(this.element.default.script.value, e)
        }
      })


      if (http.json) {
        http.json = dynamicFunction(http.json, this.data);
      }

      this.httpStore.send(http).then(res => {
        try {
          this.data[this.element.id] = dynamicFunction(http.script.post.value, {response: res});
        } catch (err) {
          this.message(this.element.label + "请求处理异常：" + err, 'error');
        }
      }).catch(err => this.message(this.element.label + "请求处理异常：" + err, 'error'))
    },
    getStyle() {

      if (this.element.attrs.style) {
        let script = this.element.attrs.style.value;
        let params = this.data;
        try{
          return dynamicFunction(script, params);
        }catch (e){
          return {}
        }
      }
    },

  }
}

</script>

<style scoped lang="scss">

</style>